import { render, staticRenderFns } from "./Laboratorios.vue?vue&type=template&id=0ce2ce94&scoped=true"
import script from "./Laboratorios.vue?vue&type=script&lang=js"
export * from "./Laboratorios.vue?vue&type=script&lang=js"
import style0 from "./Laboratorios.vue?vue&type=style&index=0&id=0ce2ce94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce2ce94",
  null
  
)

export default component.exports